import AuthAxios from '../../models/Axios';
import { LOCAL_URL, AUTH_SERVICE_URL } from '../../helper/constant';
import * as Types from '../../constants/actionTypes';
import Auth from '../../models/Auth';
import * as FileSaver from 'file-saver';

const END_POINT = {
    //
    LIST_USER: '/portal/users/portalListUsers',
    CREATE_USER: '/portal/signup',
    UPDATE_USER: '/portal/users/updatePortalUserInfo',
    DELETE_USERS: '/portal/users/deletePortalUsers',
    USER_BY_ID: '/portal/users/getPortalUserInfo',
    SET_MFA: '/portal/users/setPortalUserMFAPreference',

    ACCOUNT_SETTING: '/portal/users/accountSetting',
    //
    USER_GROUP: '/portalusergroups',

    GET_USER_GROUP_BY_USERID: '/portalusergroups/getbyuid',

    LIST_PORTAL_USER_COUNTRIES: '/portalusercountries',
    PORTAL_UNAPPROVED_USERS: '/approvaluser/getList',
}
export const PORTAL_USERS_LIST = async (payload) => {
    try {
        const response = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}${END_POINT.LIST_USER}`, { params: { ...payload } });
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}
export const CLEAR_PORTAL_USERS = () => (dispatch) => {
    dispatch({
        type: Types.LIST_USER,
        data: []
    })
}

export const CLEAR_OLD_PORTAL_USER_PAGE_EVALUATIONS = (isPrevious, isAll) => (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_PAGE_LAST_EVALUATED_KEY, popClear: true, isPrevious, isAll })

}

export const GET_PORTAL_USER_BY_ID = (payload) => async (dispatch) => {

    try {
        const { portalId, clientId, userId } = payload
        if (!portalId || !clientId || !userId) {
            return dispatch({ type: Types.USER_ERR, userErr: `Please Provide Portal User Information` })
        }

        const { data } = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}${END_POINT.USER_BY_ID}`, { params: payload });
        dispatch({ type: Types.USER_BY_ID_INFO, data: data.data })
        return data?.data
    } catch (error) {
        dispatch({ type: Types.USER_ERR, userErr: error && error.message })
    }
}

export const SET_USER_ERR = (message) => (dispatch) => {
    dispatch({ type: Types.USER_ERR, userErr: message })
}
export const GET_USER_GROUP_BY_USERID = (payload) => async (dispatch) => {
    if (Auth.isLoadPortalUID) {
        console.log('User Group/Portal User setting is already loaded')
        return
    }
    dispatch({ type: Types.USER_GROUP_REF_KEY, refKey: 0 })
    try {
        payload.ref = payload.ref ? true : false;
        const { data } = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.GET_USER_GROUP_BY_USERID}`, {
            params: payload
        });
        Auth.setUserGroup(data.data);

        dispatch({ type: Types.USER_GROUP, data: data.data })
        dispatch({ type: Types.USER_GROUP_REF_KEY, refKey: Math.random() })
    } catch (exception) {
        dispatch({ type: Types.USER_GROUP_ERR, err: exception.message })
        dispatch({ type: Types.USER_GROUP_REF_KEY, refKey: Math.random() })
    }
}

export const CLEAR_USER_GROUP_BY_USERID = () => (dispatch) => {
    dispatch({ type: Types.USER_GROUP, data: [] })
}

export const CLEAR_PORTAL_USER_GROUP_LIST = () => (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_GROUP, portalUserGroupList: [] })
}


export const GET_USER_GROUP_List = (payload) => async (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_GROUP_ERR, err: '' })
    try {
        const { portalId, clientId } = payload;

        if (!portalId || !clientId) {
            return
        }

        const { data } = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.USER_GROUP}/getPortalUserGroupList`, { params: payload });

        if (data && data.data) {
            dispatch({ type: Types.PORTAL_USER_GROUP, portalUserGroupList: data.data })
        } else {

        }
    } catch (exception) {
        dispatch({ type: Types.PORTAL_USER_GROUP_ERR, err: exception.message })
    }
}

export const SEND_PORTAL_USER_MFA_PREFERENCE = (payload) => async (dispatch) => {
    try {
        const { username, userId, phone, mfaType } = payload
        if (mfaType === 'SMS-MFA' && !phone) {
            return dispatch({ type: Types.USER_ERR, userErr: `Phone Number is not provided, Please update phone number ` })
        }
        if (!username || !userId) {
            return dispatch({ type: Types.USER_ERR, userErr: `Portal User Information is not found` })
        }
        const SMS_MFA_URL = `${AUTH_SERVICE_URL}${END_POINT.SET_MFA}`;
        await AuthAxios.axios.post(SMS_MFA_URL, payload)

    } catch (error) {
        return dispatch({ type: Types.USER_ERR, userErr: error && error.message })
    }
}

export const LIST_PORTAL_USER_COUNTRIES = (payload) => async (dispatch) => {
    try {
        const result = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.LIST_PORTAL_USER_COUNTRIES}/getPortalUserCountries`, { params: payload });
        dispatch({ type: Types.PORTAL_USER_COUNTRIES_LIST, payload: result?.data?.data });
        return result?.data?.data
    } catch (exception) {
        dispatch({ type: Types.PORTAL_USER_COUNTRIES_LIST_ERROR, countryError: exception.message });
    }
}

// export const LIST_ALL_PORTAL_COUNTRIES = (payload) => async (dispatch) => {
//     try {
//         const result = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.LIST_PORTAL_USER_COUNTRIES}/getAllPortalUserCountries`, { params: payload });
//         dispatch({ type: Types.ALL_PORTAL_USER_COUNTRIES_LIST, payload: result.data.data });
//     } catch (exception) {
//         dispatch({ type: Types.PORTAL_USER_COUNTRIES_LIST_ERROR, countryError: exception.message });
//     }
// }

export const CLEAR_PORTAL_USER_COUNTRIES = () => async (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_COUNTRIES_LIST, payload: [] });
    dispatch({
        type: Types.PORTAL_USER_COUNTRIES_ADDED_SUCCESS,
        payload: []
    });


}

export const ADD_PORTAL_USER_COUNTRY = (payload) => async (dispatch) => {
    if (!payload.countries) {
        return;
    }
    try {
        const results = await AuthAxios.axios.post(`${LOCAL_URL}${END_POINT.LIST_PORTAL_USER_COUNTRIES}/createPortalUserCountries`, payload);
        dispatch({
            type: Types.PORTAL_USER_COUNTRIES_ADDED_SUCCESS,
            payload: results.data && results.data.data ? results.data.data.map(item => item.id) : []
        });
    } catch (error) {
        dispatch({ type: Types.PORTAL_USER_COUNTRIES_ADDED_ERROR, payload: error });
    }
}

export const DELETE_USER_COUNTRY = (payload, deletedUserCountryIndex) => async (dispatch) => {
    try {
        await AuthAxios.axios.post(`${LOCAL_URL}${END_POINT.LIST_PORTAL_USER_COUNTRIES}/deletePortalUserCountry`, payload);
        dispatch({ type: Types.DELETED_USER_COUNTRY, deletedUserCountryIndex });
    } catch (exception) {
        dispatch({ type: Types.DELETED_USER_COUNTRY_ERROR, countryError: exception.message });
    }
}

// actions for bulk upload
export const DOWNLOAD_USER_TEMPLATE = async (params) => {
    try {
        const url = `${AUTH_SERVICE_URL}/portal/users/downloadUserTemplate`;
        const response = await AuthAxios.axios.get(url, { responseType: 'blob', params: { r: Math.random(), ...params } })
        let disp = response.headers['content-disposition'] || ''
        let kk = disp.split('filename=')
        let k1 = kk[1]?.split(';')[0]
        let filename = (k1 || 'Bulk_Upload_Users').replace(/["]+/g, '')
        let blob = response.data
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        throw error
    }
}

export const UPLOAD_BULK_USERS = async (formData) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/portal/users/importUsers`;
        const response = await AuthAxios.axios.post(ADDRESS_URL, formData)
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}
export const DOWNLOAD_USER_LIST = async (params) => {
    try {
        const url = `${AUTH_SERVICE_URL}/portal/users/downloadUsers`;
        const response = await AuthAxios.axios.get(url, { responseType: 'blob', params: { r: Math.random(), ...params } })
        let disp = response.headers['content-disposition'] || ''
        let kk = disp.split('filename=')
        let k1 = kk[1]?.split(';')[0]
        let filename = (k1 || 'Users').replace(/["]+/g, '')
        let blob = response.data
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        throw error
    }
}
export const DOWNLOAD_USER_GROUPS = async (params) => {
    try {
        const url = `${AUTH_SERVICE_URL}/portal/users/downloadUserGroups`;
        const response = await AuthAxios.axios.get(url, { responseType: 'blob', params: { r: Math.random(), ...params } })
        let disp = response.headers['content-disposition'] || ''
        let kk = disp.split('filename=')
        let k1 = kk[1]?.split(';')[0]
        let filename = (k1 || 'UserGroups').replace(/["]+/g, '')
        let blob = response.data
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        throw error
    }
}

export const GET_ALL_PROGRAM_LANGUAGES = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: `Please provide Portal Information` })
            return;
        }
        const URL = `${LOCAL_URL}/portalcultures/getPortalCultureList`

        const response = await AuthAxios.axios.get(URL, { params: payload })
        console.log('allProgramLanguages:', response.data.data.items)
        dispatch({
            type: Types.GET_ALL_PROGRAM_LANGUAGES_SUCCESS,
            allProgramLanguages: response.data.data.items
        })
    } catch (err) {
        dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: err });
    }
}

export const GET_ALL_PROGRAM_LANGUAGES2 = async (payload) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            return ({ message: `Please provide Portal Information` })
        }
        const URL = `${LOCAL_URL}/portalcultures/getPortalCultureList`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        return response;
    } catch (error) {
        return error
    }
}

export const LIST_ADMIN_USER = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}/portal/users/getAdminUser`, { params: payload });
        return response.data && response.data.data

    } catch (error) {
        return dispatch({
            type: Types.USER_ERR,
            userErr: error && error.message
        })
    }
}

export const UPDATE_ACCOUNT_SETTING = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${END_POINT.ACCOUNT_SETTING}`, payload);
        return response.data && response.data.data
    } catch (error) {
        return dispatch({
            type: Types.USER_ERR,
            userErr: error.message
        })
    }
}
export const GET_ACCOUNT_SETTING = (payload) => async (dispatch) => {
    try {
        const { portalId, userId } = payload
        if (!portalId || !userId) {
            return dispatch({
                type: Types.USER_ERR,
                userErr: `Invalid input parameters`
            })
        }
        const URL = `${AUTH_SERVICE_URL}${END_POINT.ACCOUNT_SETTING}`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        return response.data && response.data.data
    } catch (error) {
        return dispatch({
            type: Types.USER_ERR,
            userErr: error.message
        })
    }
}

export const CREATE_NEW_USER_OF_PORTAL = async (payload) => {
    try {
        const { portalId, username } = payload
        if (!portalId || !username) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${END_POINT.CREATE_USER}`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const UPDATE_NEW_USER_OF_PORTAL = async (payload) => {
    try {
        const { portalId, userId, username } = payload
        if (!portalId || !userId || !username) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${END_POINT.UPDATE_USER}`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const GET_PORTAL_USER_COUNTRIES = async (payload) => {
    try {
        const { portalId, userId, } = payload
        if (!portalId || !userId) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.LIST_PORTAL_USER_COUNTRIES}/getPortalUserCountries`, { params: payload });
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const GET_PORTAL_USER = async (payload) => {
    try {
        const { portalId, userId } = payload
        if (!portalId || !userId) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}${END_POINT.USER_BY_ID}`, { params: payload });
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const RESEND_ACTIVATION_LINK_BY_ADMIN = async (payload) => {
    try {
        const { userId, portalId } = payload
        if (!portalId || !userId) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/resend-account-activation-link-by-admin`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const DELETE_USERS = async (payload) => {
    try {
        const { userIds, portalId } = payload
        if (!portalId || !userIds || userIds.length === 0) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${END_POINT.DELETE_USERS}`, payload);
        return response.data && response.data.data
    } catch (error) {
        return error
    }
}

export const PORTAL_UNAPPROVED_USERS_LIST = async (payload) => {
    try {
        const response = await AuthAxios.axios.get(`${LOCAL_URL}${END_POINT.PORTAL_UNAPPROVED_USERS}`, { params: { ...payload } });
        return response.data && response?.data?.data
    } catch (error) {
        return error
    }
}

export const GET_DEALER_TERMS_AND_CONDITIONS = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: `Please provide Portal Information` })
            return;
        }
        const URL = `${AUTH_SERVICE_URL}/portal/users/downloadDealerTermsAndConditions`
        const response = await AuthAxios.axios.post(URL, payload, {
            responseType: 'blob'
        })
        // const blob = new Blob([response.data], { 
        //     type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        // })
        // const downloadUrl = window.URL.createObjectURL(new Blob([blob]))
        // const link = document.createElement('a')
        // link.href = downloadUrl
        // link.download = 'DealerTermsAndConditions.docx'
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        // window.URL.revokeObjectURL(downloadUrl)

        const contentType = response.headers['content-type'];

        if (contentType && contentType.includes('application/json')) {
            const text = await response.data.text();
            const jsonData = JSON.parse(text); 
            const message = jsonData.message || jsonData
            if (message) {
                return jsonData
            }
        } else {
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = 'Dealer_Terms_And_Conditions.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }
    } catch (err) {
        return err
    }
}

export const GET_RENTAL_CONTAINER_DATASHEET = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: `Please provide Portal Information` })
            return;
        }
        const URL = `${AUTH_SERVICE_URL}/portal/users/downloadRentalContainerDatasheet`
        const response = await AuthAxios.axios.post(URL, payload, {
            responseType: 'blob'
        })

        const contentType = response.headers['content-type'];

        if (contentType && contentType.includes('application/json')) {
            const text = await response.data.text();
            const jsonData = JSON.parse(text); 
            const message = jsonData.message || jsonData
            if (message) {
                return jsonData
            }
        } else {
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = 'Container_Rental_Options.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }
    } catch (err) {
        return err
    }
}

export const GET_RENTAL_CONTAINER_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: `Please provide Portal Information` })
            return;
        }
        const URL = `${AUTH_SERVICE_URL}/portal/users/downloadRentalContainerDocument`
        const response = await AuthAxios.axios.post(URL, payload, {
            responseType: 'blob'
        })

        const contentType = response.headers['content-type'];

        if (contentType && contentType.includes('application/json')) {
            const text = await response.data.text();
            const jsonData = JSON.parse(text); 
            const message = jsonData.message || jsonData
            if (message) {
                return jsonData
            }
        } else {
            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = 'Container_Rental_Contract_Document.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }
    } catch (err) {
        return err
    }
}

export const GENERATE_REQUEST_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_LANGUAGES_ERROR, programLanguagesError: `Please provide Portal Information` })
            return;
        }
        const URL = `${AUTH_SERVICE_URL}/portal/users/generateRentalContainerDocument`
        const response = await AuthAxios.axios.post(URL, payload)
        return response.data && response.data.data
    } catch (err) {
        return err
    }
}

const extractErrorMessage = async (response) => {
    const data = response?.data ?? response
    if (!data) {
        return null
    }

    if (typeof data === 'object' && !(data instanceof Blob) && !(data instanceof ArrayBuffer)) {
        return data.message || data.error?.message || null
    }

    try {
        let text
        if (data instanceof Blob) {
            text = await data.text()
        } else if (typeof data === 'string') {
            text = data
        } else if (data instanceof ArrayBuffer) {
            text = new TextDecoder().decode(data)
        } else {
            return null
        }
        const parsed = JSON.parse(text)
        return parsed?.message || parsed?.error?.message || null
    } catch (e) {
        return null
    }
}

const downloadBlobDocument = async (url, payload, defaultFileName) => {
    try {
        const response = await AuthAxios.axios.post(url, payload, {
            responseType: 'blob',
            skipGlobalErrorToast: true,
        })
        const contentType = response.headers['content-type']
        if (contentType && contentType.includes('application/json')) {
            const message = await extractErrorMessage(response)
            throw new Error(message || 'Failed to generate document')
        }
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        const disposition = response.headers['content-disposition']
        const match = disposition?.match(/filename=([^;]+)/)
        link.download = match ? match[1].trim() : defaultFileName
        link.click()
        window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
        const parsedMessage = await extractErrorMessage(error?.response)
        const message = parsedMessage
            || (error?.message && error.message !== error?.statusText ? error.message : null)
            || 'Failed to generate document'
        throw new Error(message)
    }
}

export const DOWNLOAD_TRANSPORT_ORDER_DIRECTLY = (payload) => async () => {
    const URL = `${AUTH_SERVICE_URL}/portal/users/generateTransportOrderDirectly`
    await downloadBlobDocument(URL, payload, `transport-order-${payload.requestId}.xlsx`)
}

export const DOWNLOAD_ABIS_NUMBER_DOCUMENT_DIRECTLY = (payload) => async () => {
    const URL = `${AUTH_SERVICE_URL}/portal/users/generateAbisNumberDocumentDirectly`
    await downloadBlobDocument(URL, payload, `abis-number-document-${payload.requestId}.xlsx`)
}